module.exports = __webpack_public_path__ + "static/pin-teal-5650d50d49cbeb502715c39330545501.png";